'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NUMBER_FORMATTERS;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../utils');

var _NumberTypes = require('../constants/NumberTypes');

var _NumberTypes2 = _interopRequireDefault(_NumberTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NUMBER_FORMATTERS = (_NUMBER_FORMATTERS = {}, _defineProperty(_NUMBER_FORMATTERS, _NumberTypes2.default.DECIMAL, _utils.formatNumber), _defineProperty(_NUMBER_FORMATTERS, _NumberTypes2.default.CURRENCY, _utils.formatCurrency), _defineProperty(_NUMBER_FORMATTERS, _NumberTypes2.default.PERCENTAGE, _utils.formatPercentage), _NUMBER_FORMATTERS);

exports.default = _react2.default.createClass({
  displayName: 'FormattedNumber',

  propTypes: {
    currencyCode: _react.PropTypes.string,
    precision: _react.PropTypes.number,
    simplifyCurrency: _react.PropTypes.bool,
    stripInsignificantZeros: _react.PropTypes.bool,
    style: _react.PropTypes.oneOf(Object.keys(_NumberTypes2.default).map(function (key) {
      return _NumberTypes2.default[key];
    })),
    unit: _react.PropTypes.string,
    value: _react.PropTypes.number.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      simplifyCurrency: false,
      stripInsignificantZeros: true,
      style: _NumberTypes2.default.DECIMAL
    };
  },
  render: function render() {
    var _props = this.props,
        value = _props.value,
        style = _props.style,
        simplifyCurrency = _props.simplifyCurrency,
        stripInsignificantZeros = _props.stripInsignificantZeros,
        options = _objectWithoutProperties(_props, ['value', 'style', 'simplifyCurrency', 'stripInsignificantZeros']);

    var numberFormatter = NUMBER_FORMATTERS[style];

    if (simplifyCurrency && value % 1 === 0) {
      options.precision = 0;
    }

    if (stripInsignificantZeros) {
      options.strip_insignificant_zeros = true;
    }

    return _react2.default.createElement(
      'span',
      null,
      numberFormatter(value, options)
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.245/js/components/FormattedNumber.js
// module id = 284
// module chunks = 0